<template>
  <component
    :is="component"
    v-bind="props"
  />
</template>

<script>
import Authenticate from '../components/Authenticate.vue'
import AccountMenuItem from '../components/AccountMenuItem.vue'
import AccountPage from '../components/AccountPage.vue'
import ArtaEstimateWidget from '../components/Arta/EstimateWidget.vue'
import Banner from '../components/Banner.vue'
import BiddingArea from '../components/BiddingArea.vue'
import BiddingStatus from '../components/BiddingStatus.vue'
import Breadcrumbs from '../components/Breadcrumbs.vue'
import FavoriteHeart from '../components/FavoriteHeart.vue'
import ItemList from '../components/ItemList.vue'
import LotNavigation from '../components/LotNavigation.vue'
import Modal from '../components/Modal.vue'
import PayInvoiceButton from '../components/PayInvoiceButton.vue'
import PhoneList from '../components/PhoneList.vue'
import PhoneAction from '../components/PhoneAction.vue'
import PhonePodium from '../components/PhonePodium.vue'
import PhoneBiddingArea from '../components/PhoneBiddingArea.vue'
import PodiumScreen from '../components/PodiumScreen.vue'
import PusherMain from '../components/PusherMain.vue'
import PusherVirtualAuctioneer from '../components/PusherVirtualAuctioneer.vue'
import LiveMode from '../components/LiveMode.vue'
import SignIn from '../components/Cards/SignIn.vue'
import SignOut from '../components/Cards/SignOut.vue'
import CheckoutComponent from '../components/Checkout/CheckoutComponent.vue'
import ContractForm from './Contract/ContractForm.vue'
import AuctionItemsComponent from '../components/Checkout/AuctionItemsComponent.vue'
import ShippingComponent from '../components/Checkout/ShippingComponent.vue'
import ShippingOptionsComponent from '../components/Checkout/ShippingOptionsComponent.vue'
import PaymentInfoComponent from '../components/Checkout/PaymentInfoComponent.vue'
import SignInCheckoutComponent from '../components/Checkout/SignInCheckoutComponent.vue'
import CertCaptureComponent from '../components/CertCapture/CertCaptureComponent.vue'
import PopupMessage from '../components/PopupMessage.vue'
import TaxExemptPopupMessage from '../components/TaxExemptPopupMessage.vue'
import EditAccountComponent from '../components/Account/EditAccountComponent.vue'
import UpdateEmailComponent from '../components/Account/UpdateEmailComponent.vue'
import PaymentMethodsComponent from '../components/Account/PaymentMethodsComponent.vue'
import ManageTwoFactorAuthenicationComponent from '../components/Account/ManageTwoFactorAuthenicationComponent.vue'
import TwoFactorEmailPinComponent from '../components/Account/TwoFactorEmailPinComponent.vue'
import AuctionConsoleComponent from '../components/Staff/AuctionConsole/AuctionConsoleComponent.vue'
import SellInquiryForm from '../components/Forms/SellInquiry/Form.vue'
import PageNotFoundComponent from './PageNotFoundComponent.vue'

export default {
	name: 'DynamicComponent',
	components: {
		AuctionConsoleComponent,
		AuctionItemsComponent,
		Authenticate,
		AccountMenuItem,
		AccountPage,
        ArtaEstimateWidget,
		Banner,
		BiddingArea,
		BiddingStatus,
		Breadcrumbs,
		CheckoutComponent,
		CertCaptureComponent,
        ContractForm,
		EditAccountComponent,
		FavoriteHeart,
		ItemList,
		LotNavigation,
		ManageTwoFactorAuthenicationComponent,
		Modal,
		PayInvoiceButton,
		PaymentInfoComponent,
		PaymentMethodsComponent,
		PhoneList,
		PhoneAction,
		PhonePodium,
		PhoneBiddingArea,
		PodiumScreen,
		PopupMessage,
		PusherMain,
		PusherVirtualAuctioneer,
		LiveMode,
		SellInquiryForm,
		ShippingComponent,
		ShippingOptionsComponent,
		SignIn,
		SignInCheckoutComponent,
		SignOut,
		TaxExemptPopupMessage,
		TwoFactorEmailPinComponent,
		UpdateEmailComponent,
        PageNotFoundComponent
	},
	props: [
		'serviceLocations',
		'component',
		'props'
	],
	data () {
		return {

		}
	},
	beforeMount: function () {
		this.$store.dispatch('setServiceLocations', this.serviceLocations)
	}
}
</script>

<style scoped></style>
